<template>
  <div class="addMessageType">
    <!--新增-->
    <el-dialog
      :title="$t('messageType.form.messageTempAddTitle')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="500px"
    >
      <el-form
        label-width="auto"
        :rules="rules"
        :model="addList"
        ref="addList"
        :label-position="'right'"
      >
        <el-form-item :label="$t('messageType.form.type')" prop="messageTypeId">
          <el-select
            v-model="addList.messageTypeId"
            :placeholder="$t('messageType.form.messageTypeIdPlaceholder')"
            filterable
            @change="selectType"
            clearable
          >
            <el-option
              v-for="item in messageTypeList"
              :key="item.id"
              :label="item.messageTypeName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('messageType.form.title')" prop="title">
          <el-input
            v-model="addList.title"
            :placeholder="$t('messageType.form.titlePlaceholder')"
            maxlength="32"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageType.form.content')" prop="content">
          <el-input
            v-model="addList.content"
            :placeholder="$t('messageType.form.contentPlaceholder')"
            maxlength="32"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageType.form.redirectUrl')" prop="redirectUrl">
          <el-input
            v-model="addList.redirectUrl"
            :placeholder="$t('messageType.form.redirectUrlPlaceholder')"
            maxlength="32"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAdd = false">{{ $t('dialog.cancel') }}</el-button>
        <el-button type="primary" @click="addSure()">{{ $t('dialog.save') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import API from '@/api/messageCenter/messageTemp.js';
  export default {
    name: 'addMessageTemp',
    data() {
      // 校验特殊字符
      // var specialValidate = (rule, value, callback) => {
      //   var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
      //   if (value.match(reg)) {
      //     callback(new Error(this.$t('confirm.donNotEmoticons')));
      //   } else {
      //     callback();
      //   }
      // };
      return {
        dialogAdd: false,
        messageTypeList: [],
        addList: {
          messageTypeId: '',
          title: '',
          content: '',
          redirectUrl: '',
        },
        rules: {
          messageTypeId: [
            {
              required: true,
              message: this.$t('messageType.form.messageTypeIdPlaceholder'),
              trigger: 'blur',
            },
          ],
          title: [
            {
              required: true,
              message: this.$t('messageType.form.titlePlaceholder'),
              trigger: 'blur',
            },
          ],
          content: [
            {
              required: true,
              message: this.$t('messageType.form.contentPlaceholder'),
              trigger: 'blur',
            },
          ],
        },
      };
    },
    methods: {
      openDialog(flag) {
        if (this.$refs['addList']) {
          this.$refs['addList'].resetFields();
        }
        this.dialogAdd = flag;
        this.getTypeList();
      },
      //选择消息类型
      selectType(val) {
        this.messageTypeList.map((item) => {
          if (val == item.id) {
            this.addList.messageTypeId = item.id;
            this.addList.messageTypeName = item.messageTypeName;
          }
        });
      },
      //获取消息类型列表
      getTypeList() {
        this.$axios.get(API.MESSAGE_TYPE_LIST_API).then((res) => {
          if (0 != res.data.code) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          } else {
            this.messageTypeList = res.data.data;
          }
        });
      },
      //保存
      addSure() {
        this.$refs.addList.validate((valid) => {
          if (valid) {
            this.$axios.post(API.MESSAGE_TEMP_ADD_API, this.addList).then((res) => {
              if (0 != res.data.code) {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              } else {
                this.dialogAdd = false;
                this.$emit('getData');
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'success',
                });
              }
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>
